/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReportTab200ResponseProductsInnerAllOfDiscount } from './GetReportTab200ResponseProductsInnerAllOfDiscount';
import {
    GetReportTab200ResponseProductsInnerAllOfDiscountFromJSON,
    GetReportTab200ResponseProductsInnerAllOfDiscountFromJSONTyped,
    GetReportTab200ResponseProductsInnerAllOfDiscountToJSON,
    GetReportTab200ResponseProductsInnerAllOfDiscountToJSONTyped,
} from './GetReportTab200ResponseProductsInnerAllOfDiscount';
import type { GetReportTab200ResponseProductsInnerAllOfModifiersInner } from './GetReportTab200ResponseProductsInnerAllOfModifiersInner';
import {
    GetReportTab200ResponseProductsInnerAllOfModifiersInnerFromJSON,
    GetReportTab200ResponseProductsInnerAllOfModifiersInnerFromJSONTyped,
    GetReportTab200ResponseProductsInnerAllOfModifiersInnerToJSON,
    GetReportTab200ResponseProductsInnerAllOfModifiersInnerToJSONTyped,
} from './GetReportTab200ResponseProductsInnerAllOfModifiersInner';

/**
 * 
 * @export
 * @interface GetReportTab200ResponseProductsInnerAllOfComboProductsInner
 */
export interface GetReportTab200ResponseProductsInnerAllOfComboProductsInner {
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseProductsInnerAllOfComboProductsInner
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseProductsInnerAllOfComboProductsInner
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseProductsInnerAllOfComboProductsInner
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseProductsInnerAllOfComboProductsInner
     */
    finalPrice?: number;
    /**
     * 
     * @type {GetReportTab200ResponseProductsInnerAllOfDiscount}
     * @memberof GetReportTab200ResponseProductsInnerAllOfComboProductsInner
     */
    discount?: GetReportTab200ResponseProductsInnerAllOfDiscount;
    /**
     * 
     * @type {boolean}
     * @memberof GetReportTab200ResponseProductsInnerAllOfComboProductsInner
     */
    deleted: boolean;
    /**
     * 
     * @type {Array<GetReportTab200ResponseProductsInnerAllOfModifiersInner>}
     * @memberof GetReportTab200ResponseProductsInnerAllOfComboProductsInner
     */
    modifiers?: Array<GetReportTab200ResponseProductsInnerAllOfModifiersInner>;
}

/**
 * Check if a given object implements the GetReportTab200ResponseProductsInnerAllOfComboProductsInner interface.
 */
export function instanceOfGetReportTab200ResponseProductsInnerAllOfComboProductsInner(value: object): value is GetReportTab200ResponseProductsInnerAllOfComboProductsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseProductsInnerAllOfComboProductsInnerFromJSON(json: any): GetReportTab200ResponseProductsInnerAllOfComboProductsInner {
    return GetReportTab200ResponseProductsInnerAllOfComboProductsInnerFromJSONTyped(json, false);
}

export function GetReportTab200ResponseProductsInnerAllOfComboProductsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseProductsInnerAllOfComboProductsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'quantity': json['quantity'],
        'price': json['price'],
        'finalPrice': json['finalPrice'] == null ? undefined : json['finalPrice'],
        'discount': json['discount'] == null ? undefined : GetReportTab200ResponseProductsInnerAllOfDiscountFromJSON(json['discount']),
        'deleted': json['deleted'],
        'modifiers': json['modifiers'] == null ? undefined : ((json['modifiers'] as Array<any>).map(GetReportTab200ResponseProductsInnerAllOfModifiersInnerFromJSON)),
    };
}

export function GetReportTab200ResponseProductsInnerAllOfComboProductsInnerToJSON(json: any): GetReportTab200ResponseProductsInnerAllOfComboProductsInner {
    return GetReportTab200ResponseProductsInnerAllOfComboProductsInnerToJSONTyped(json, false);
}

export function GetReportTab200ResponseProductsInnerAllOfComboProductsInnerToJSONTyped(value?: GetReportTab200ResponseProductsInnerAllOfComboProductsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'quantity': value['quantity'],
        'price': value['price'],
        'finalPrice': value['finalPrice'],
        'discount': GetReportTab200ResponseProductsInnerAllOfDiscountToJSON(value['discount']),
        'deleted': value['deleted'],
        'modifiers': value['modifiers'] == null ? undefined : ((value['modifiers'] as Array<any>).map(GetReportTab200ResponseProductsInnerAllOfModifiersInnerToJSON)),
    };
}

